import { formatCurrentDate } from "utils/date";
import checkmark from '../../assets/checkmark.png';
import editrecord from '../../assets/editrecord.png';
import pdf from '../../assets/pdf.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCirclePlay, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { formatTimestampToDDMMDtYYYY } from "utils/date";
import Ring from "pages/landing/ring";
import { DateTime } from 'luxon';
import summarizedpng from '../../assets/summarized.png'
import { useNavigate } from "react-router-dom";

import BasicPdfRender from "basic/basicutils/basicpdfrender";
import { useEffect, useState } from "react";
import api from "api/api";
import ClearIcon from '@mui/icons-material/Clear';
import { Backdrop, Chip, CircularProgress, Stack, Tooltip } from "@mui/material";
import useModalStore from "zustand/zustandstore";
import AudioModal from "basic/modals/audiomodal";
import { toZonedTime } from "date-fns-tz";
import { useSelector } from "react-redux";
import { decodeTimeToISO } from "utils/date";

import { clearPersistedData } from "../../redux/store";
import ToastMessage from "utils/muialerts/righttoptoast";
import TemplateDeleteModal from "pages/templatecreation/templatedeletemodal";
import DeleteRecord from "basic/modals/deleterecord";
import TextModal from "basic/basicutils/notesmodal";
const storedDate = (x) => {
  let normaldate = [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ];
  const dateFilter = x?.filter_array?.date_filter;

  if (
    !dateFilter ||
    !dateFilter.start_date ||
    !dateFilter.end_date 

  ) {
    return normaldate;
  } else {
    let changed = [
      {
        startDate: new Date(dateFilter.start_date),
        endDate: new Date(dateFilter.end_date),
        key: "selection",
      },
    ];
    return changed;
  }
};
const formatChipDate = (date) => {
  // Check if the input is a valid Date
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return false; // Return false for invalid dates
  }

  // Convert the date to the desired timezone
  const timezone = 'Asia/Kolkata'; // Adjust the timezone as needed
  const zonedDate = toZonedTime(date, timezone);
  const today = toZonedTime(new Date(), timezone); // Get today's date in the same timezone

  // Normalize both dates to remove time components
  const isSameDay = zonedDate.getFullYear() === today.getFullYear() &&
    zonedDate.getMonth() === today.getMonth() &&
    zonedDate.getDate() === today.getDate();

  if (isSameDay) {
    return false; // Return false if the date is today
  }

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const dayOfMonth = zonedDate.getDate();
  const month = months[zonedDate.getMonth()];
  const year = zonedDate.getFullYear();

  // Format the date as "2 Sep, 2024"
  return `${dayOfMonth} ${month.slice(0, 3)}, ${year}`; // Shortened month name
};
const formatChipDatee = (date) => {
  // Check if the input is a valid Date
  if (!(date instanceof Date) || isNaN(date.getTime())) {
    return false; // Return false for invalid dates
  }

  // Convert the date to the desired timezone
  const timezone = 'Asia/Kolkata'; // Adjust the timezone as needed
  const zonedDate = toZonedTime(date, timezone);
  const today = toZonedTime(new Date(), timezone); // Get today's date in the same timezone

  // Normalize both dates to remove time components
  const isSameDay = zonedDate.getFullYear() === today.getFullYear() &&
    zonedDate.getMonth() === today.getMonth() &&
    zonedDate.getDate() === today.getDate();

  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

  const dayOfMonth = zonedDate.getDate();
  const month = months[zonedDate.getMonth()];
  const year = zonedDate.getFullYear();

  // Format the date as "2 Sep, 2024"
  return `${dayOfMonth} ${month.slice(0, 3)}, ${year}`; // Shortened month name
};
const BasicTable = ({data,fetchdashboardData,handletimeStamp}) => {
  const mydata=useModalStore()
const navigate=useNavigate()
const [ispdfshow,setIspdfShow]=useState(false)
const [loading,setLoading]=useState(false)
const[mycard,setMyCard]=useState('')
const savedload = useSelector((state) => state.data.savedload);
const {setModalValue} = useModalStore()
const[deletemodal,setDeletemodal]=useState(false);
const [pdffile,setPdffile]=useState()
const [alertmessage, setAlertMessage] = useState('');
const [open, setOpen] = useState(false);
const [selectedItem,setSelectedItem]=useState()
const [elapsedTime, setElapsedTime] = useState(0);
const [severity, setSeverity] = useState('success');
const [audioSrc, setAudioSrc] = useState(null);
const [isModalOpen, setIsModalOpen] = useState(false);
const[textModal,setTextModal]=useState(false)
const[savednotes,setsavedNotes]=useState('')
const handleClose = (event, reason) => {
  if (reason === 'clickaway') {
    return;
  }
  setOpen(false);
};
const handleDelete = async (id) => {
  try {
    setLoading(true);
    const response = await api.delete('/v1/recording/delete', {
      data: {
        rowid: id, // Sending the payload with rowid
      },
    });
    // setModalValue({trigger:true})
    
    setAlertMessage('Record Has Been Deleted')
    setOpen(true)
    fetchdashboardData()
  } catch (error) {
    console.error('Error deleting record:', error);
  } finally {
    setLoading(false);
  }
};
useEffect(() => {
  let interval = null;
  if (data.some((item) => item.transcriptionstatus === "Processing")) {
    interval = setInterval(() => {
      setElapsedTime((prevTime) => prevTime + 1);
    }, 1000);
  } else {
    setElapsedTime(0);
  }
  return () => {
    if (interval) clearInterval(interval);
  };
}, [data]);
const renderStatus = (item) => {
  // 2025-01-22T15:40:00

  // Render progress or status based on transcription status
  if (item.transcriptionstatus === null || item.transcriptionstatus === "") {
    return "Ready";
  } else if (item.transcriptionstatus === "Submitted") {
    return <Ring value={20} />;
  } else if (item.transcriptionstatus === "Processing") {
    const recording_duration = item.recording_duration || 200; // Fallback to a default value
    const totalProcessingTime = Math.max((420 / 1287) * recording_duration, 60);
  
  const recordingStartTime = DateTime.fromISO(item.ts).toSeconds();


// Current time in UTC, rounded to whole seconds
const currentTime = Math.floor(DateTime.now().toSeconds()); // or you can use Math.round() if you prefer rounding

    const elapsedSinceStart = Math.max(currentTime - recordingStartTime, 0);

    // Calculate the initial percentage based on the elapsed time
    const completionPercentage = Math.min(
      Math.round(20 + (70 * elapsedSinceStart) / totalProcessingTime),
      90
    );


 
    console.log('elapsed',elapsedSinceStart,'recordinstarttime',recordingStartTime,'recordingduratiojn',recording_duration
      ,'total processingtime',totalProcessingTime
    )



return <Ring value={completionPercentage} />;

  } else if (item.transcriptionstatus === "Summarized") {
    return (
      <div className="ml-2">
        <Tooltip title="Pending Review">
          <img src={summarizedpng} alt="pending review" className="w-6 h-6" />
        </Tooltip>
      </div>
    );
  } else if (item.transcriptionstatus === "APPROVED") {
    return (
      <div className="ml-2">
        <Tooltip title="Completed">
          <img src={checkmark} alt="Completed" className="w-6 h-6" />
        </Tooltip>
      </div>
    );
  } else {
    return null;
  }
}
const handleedit=(card)=>{
  if(mydata.usertype=='BUSINESS'){
      navigate(`/general-archive-edit/${card.id}`)
  }else{
    navigate(`/basic-archive-edit/${card.id}/${card.patient_name}`)
  }

}
const handleTimezones = (stamp, timezone) => {
  try {
    // Step 1: Check if timezone is an object and contains the 'timezone' key
    if (typeof timezone === 'object' && timezone !== null && 'timezone' in timezone) {
      // Extract the timezone string from the object
      const { timezone: zone } = timezone;

      // Step 2: Parse the timestamp into a DateTime object using the specific timezone
      const convertedTime = DateTime.fromISO(stamp, { zone });

      // Step 3: Format the converted time into the desired format: "Thu, Dec 26, 2024"
      return convertedTime.toFormat('EEE, LLL dd, yyyy');
    } else {
      // If timezone object is invalid, throw an error
      throw new Error('Invalid timezone object');
    }
  } catch (error) {
    // If any error occurs, return today's date in the desired format
    const today = DateTime.local(); // Get today's date in the local timezone
    return today.toFormat('EEE, LLL dd, yyyy');
  }
};


const handlepdf = async (value,card) => {
  try {
     // Trigger loading spinner
     setLoading(true); 
     const uniqueParam = new Date().getTime(); // or use a random number: Math.random() 
   // Fetch the PDF from the server with a unique parameter to prevent caching
   const response = await api.get(`/v1/basic/documents/PDF/${value}?_=${uniqueParam}`, {
     responseType: "blob", // Ensure response type is 'blob' for binary data
   });
      const pdfBlob = new Blob([response], { type: "application/pdf" });
 
     // Generate a URL for the Blob
     const pdfUrl = URL.createObjectURL(pdfBlob);
     setMyCard(card)
     setPdffile(pdfBlob)
     // Open the generated URL in a new tab
     //window.open(pdfUrl, "_blank");
 
   } catch (error) {
     console.error("Error fetching the PDF:", error);
   } finally {
     // Turn off loading spinner
     setLoading(false);
     setIspdfShow(true)
   }
 };
 const handleplay=async(audio_link)=>{
  try {
    setLoading(true)
    const response = await api.get(`/v1/audio/${audio_link}`, {
      responseType: "blob", // Make sure response is treated as a Blob
    });
    const fileBlob = response;
    const audioURL = URL.createObjectURL(fileBlob);
        setAudioSrc(audioURL);
        if(fileBlob&&fileBlob.size==0){
       setAudioSrc('')
        }
      setIsModalOpen(true)
  } catch (error) {
    console.log(error)
  }finally{
setLoading(false)
  }
 }
 const handleCloseModal = () => {
  setIsModalOpen(false);
  setAudioSrc(null); // Reset audio source when modal closes
};
const handleDateChip = () => {

  handletimeStamp({
    startDate: new Date().toISOString().split("T")[0],
    endDate: new Date().toISOString().split("T")[0],
  });

}
const handleOnclear = () => {
  clearPersistedData();
  window.location.reload()

}
const handleDeleteRecord=()=>{
  setDeletemodal(false)
  handleDelete(selectedItem.id)
}
const getFormattedText = () => {
  const formatDate = (isoDateString) => {
    const date = new Date(isoDateString);
    const options = { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric' };
    return date.toLocaleDateString('en-US', options);
  };

  // Construct the text dynamically
  const modalText = `${selectedItem.patient_name} (${selectedItem.patientid}) ${formatDate(selectedItem.ts)}`;
  return modalText;
};

  return (
    <div className={`w-full`}>
      <div className="w-full bg-white rounded-[14px] p-4 relative">
      <div className="flex flex-wrap gap-4 mb-4 items-center relative">
     
        <Stack direction="row" spacing={1} className="flex flex-wrap">
          {formatChipDate(storedDate(savedload)[0].startDate) ? 
          <Chip  label={
            formatChipDate(storedDate(savedload)[0].startDate) === formatChipDate(storedDate(savedload)[0].endDate)
              ? formatChipDate(storedDate(savedload)[0].startDate)
              : `${formatChipDate(storedDate(savedload)[0].startDate)} - ${formatChipDatee(storedDate(savedload)[0].endDate)}`
          }
             onDelete={handleDateChip}
            deleteIcon={<div style={{ color: "white" }}><ClearIcon /></div>}

            style={{
              margin: "4px", color: "#FFF", fontStyle: "normal", background: "#B4B4B4",
            }}
          /> : <></>}</Stack>

        {/* {(formatChipDate(storedDate(savedload)[0].startDate)) ?
          <div style={{ color: "#7B7575" }} onClick={() => {
            handleOnclear()
          }}>  <ClearIcon style={{ fontSize: '33px' }} />
          </div> : <></>}        */}

        
       
      </div>
        <div className="w-full max-h-[50vh] md:max-h-[55vh] overflow-y-auto custom-scrollbar">
          <table className="w-full text-left border-collapse">
            {mydata.usertype=='BUSINESS'||mydata.usertype=='BASIC'||mydata.usertype=='PLUS'?<thead className="sticky top-0 bg-white">
              <tr>
                <th className=" py-2 px-4 border-b-[1px] border-[rgba(0,0,0,0.10)] [-webkit-text-stroke:0.3px_#060606] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#060606] text-sm tracking-[0.14px] leading-[normal]">
                 {mydata.usertype=='BUSINESS'?"Conversation":"Patient Name"}
                </th>
                {mydata.usertype=='BUSINESS'?<>
                  <th className="py-2 px-4 border-b-[1px] border-[rgba(0,0,0,0.10)] [-webkit-text-stroke:0.3px_#060606] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#060606] text-sm tracking-[0.14px] leading-[normal]">
                 Notes
                </th>
                </>
:<></>
                }
                <th className="py-2 px-4 border-b-[1px] border-[rgba(0,0,0,0.10)] [-webkit-text-stroke:0.3px_#060606] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#060606] text-sm tracking-[0.14px] leading-[normal]">
                  Date
                </th>
                <th className=" py-2 px-4 border-b-[1px] border-[rgba(0,0,0,0.10)] [-webkit-text-stroke:0.3px_#060606] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#060606] text-sm tracking-[0.14px] leading-[normal]">
                  Status
                </th>
                <th className="py-2 px-4  border-b-[1px] border-[rgba(0,0,0,0.10)] [-webkit-text-stroke:0.3px_#060606] [font-family:'Poppins-Regular',Helvetica] font-normal text-[#060606] text-sm tracking-[0.14px] leading-[normal]">
            
                </th>
                
              </tr>
            </thead>:<></>}
            <tbody className="max-h-[55vh]">
  {data.length ? (
    data.map((item, index) => (
      <tr
        key={index}
        className="h-16 mb-2 hover:bg-[#A2C6FD26] cursor-pointer"
        onClick={() => {
          if(mydata.usertype=='BUSINESS'){
            if(item.transcriptionstatus === "Summarized"||(item.transcriptionstatus === "APPROVED")){
                handlepdf(item.audiolink.split(".")[0], item)
            }
          
         return
        }
          const timestamp = new Date().getTime();
          const profilePhotoUrl = null;
          navigate(`/basic-archive/${item.patientid}`, {
            state: { ts: timestamp, profile_photo: profilePhotoUrl },
          });
        }
      
      }
      >
        <td className="py-2 px-4 [font-family:'Poppins-Regular',Helvetica] font-normal text-[#060606] text-base tracking-[0] leading-[normal]">
        {mydata.usertype=='BUSINESS'?(item?.name):`${item?.patient_name} (${item?.patientid})`}
          {}
        </td>
        {mydata.usertype === 'BUSINESS' && (
          <td className="py-2 px-4 [font-family:'Poppins-Regular',Helvetica] font-normal text-[#060606] text-base tracking-[0] leading-[normal]">
  {item?.notes ? (
    item.notes.length > 20 ? (
      <>
        {item.notes.slice(0, 20)}...{" "}
        <span
          className="text-blue-500 text-sm cursor-pointer"
          onClick={(event) => {
            event.stopPropagation(); // Prevent event propagation
            setsavedNotes(item.notes);
            setTextModal(true);
          }}
        >
          View More
        </span>
      </>
    ) : (
      item.notes
    )
  ) : (
    <span className="text-gray-500 italic">No notes available</span>
  )}
</td>

)}

        <td className="py-2 px-4 [font-family:'Poppins-Regular',Helvetica] font-normal text-[#060606] text-base tracking-[0] leading-[normal]">
          {/* {formatTimestampToDDMMDtYYYY(item.ts)} */}
          {formatTimestampToDDMMDtYYYY(item.ts)}
        </td>
        <td className="py-2 px-4 w-[20%]"
     onClick={(e) => {
      e.stopPropagation();
      if (
        (item.transcriptionstatus === "Summarized" || item.transcriptionstatus === "APPROVED") &&
        item.transcriptionstatus !== "Processing"
      ) {
        // handlepdf(item.audiolink.split(".")[0], item);
        handleedit(item)  
      }
    }}
    
        >
          
         { renderStatus(item)}
        </td>
        <td className="py-2 px-4 min-h-[8vh] flex items-center gap-4 [font-family:'Poppins-Regular',Helvetica] font-normal text-base tracking-[0] leading-[normal]">
        {(item.transcriptionstatus === "Summarized")?<Tooltip title="Edit Record"><img
            src={editrecord}
            alt="Edit Icon"
            className="w-6 h-6 cursor-pointer"
            onClick={(e) => {
              e.stopPropagation();
              handleedit(item)          
            }}
          /></Tooltip>:<div className="w-6 h-6"></div>}
          {((item.transcriptionstatus === "Summarized"||(item.transcriptionstatus === "APPROVED"))&&(item.transcriptionstatus !== "Processing"))?<Tooltip title="View Pdf"><img
            onClick={(e) => {
              e.stopPropagation();
              handlepdf(item.audiolink.split(".")[0], item);
            }}
            src={pdf}
            alt="PDF"
            className="w-6 h-6 cursor-pointer"
          /></Tooltip>:<div className="w-6 h-6"></div>}
      <Tooltip title="Play">
  <FontAwesomeIcon
    icon={faCirclePlay}
    className={`w-6 h-6 cursor-pointer ${
      item.transcriptionstatus === "Processing" || item.transcriptionstatus === "Submitted"
        ? "opacity-50 cursor-not-allowed"
        : ""
    }`}
    style={{
      color: item.transcriptionstatus === "Processing" || item.transcriptionstatus === "Submitted" ? "gray" : "red",
    }}
    onClick={(e) => {
      if (item.transcriptionstatus !== "Processing" && item.transcriptionstatus !== "Submitted") {
        e.stopPropagation();
        handleplay(item.audiolink);
      }
    }}
  />
</Tooltip>

         <Tooltip title="Delete"> <FontAwesomeIcon
            icon={faTrashCan}
            className="w-6 h-6 cursor-pointer"
            style={{ color: "#7B7575" }}
            onClick={(e) => {
              e.stopPropagation();
              setSelectedItem(item)
             setDeletemodal(true)
            }}
          /> </Tooltip>
        </td>
      </tr>
    ))
  ) : (
    <></>
  )}
</tbody>

          </table>
        </div>
      </div>
      <BasicPdfRender ispdfshow={ispdfshow}setIspdfShow={setIspdfShow} pdfBlob={pdffile} data={mycard}/>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" size={40} />
      </Backdrop>
      <AudioModal
        open={isModalOpen}
        onClose={handleCloseModal}
        audioSrc={audioSrc}
        loading={loading}
      />
      <TextModal isOpen={textModal} setTextModal={setTextModal} notes={savednotes}/>
          <ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />
          <DeleteRecord isModalOpen={deletemodal} setIsDeleteModal={setDeletemodal} text={selectedItem} handledelete={handleDeleteRecord} />
    </div>
  );
};

export default BasicTable;
